<template>
  <div v-if="propositionOffre">
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Demandes de recrutement'"
          :description="'Aperçu d\'une demande de recrutement'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="propositionOffre">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence : {{ propositionOffre.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      class="mdi mdi-checkbox-blank-circle mr-1"
                      :class="{
                        'text-warning':
                          propositionOffre.statut === CONST.EN_ATTENTE,
                        'text-success':
                          propositionOffre.statut === CONST.VALIDER ||
                          propositionOffre.statut === CONST.OFFRE,
                        'text-danger':
                          propositionOffre.statut === CONST.REFUSER,
                      }"
                    ></i>
                    {{ getStatutPO(propositionOffre.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'rh_proposition_offre' }).catch(() => {})
          "
        >
          Liste des demandes
        </button>

        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({ name: 'rh_proposition_offre-create' })
              .catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle demande
        </button>

        <button
          v-if="propositionOffre.statut === 0"
          type="button"
          class="btn btn-custom-primary"
          style="min-width: 100px"
          @click.prevent="
            $router
              .push({
                name: 'rh_proposition_offre-edit',
                params: { id: id },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_EDIT" class="font-size-17"></i> Modifier
        </button>
      </div>

      <div class="col-md-12 col-lg-6">
        <b-button
          variant="success"
          class="btn-icon mr-4"
          @click="valider"
          v-if="propositionOffre.statut === CONST.EN_ATTENTE"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_VALIDATE"></i>
          </span>
          Valider
        </b-button>
        <b-button
          variant="danger"
          class="btn-icon mr-4"
          @click="refuser"
          v-if="propositionOffre.statut === CONST.EN_ATTENTE"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_REFUSE"></i>
          </span>
          Réfuser
        </b-button>

        <b-button
          variant="warning"
          class="btn-icon"
          @click="reinitialiser"
          v-if="propositionOffre.statut !== CONST.EN_ATTENTE"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_RESET"></i>
          </span>
          Réinitialiser
        </b-button>

        <button
          v-if="propositionOffre.statut === CONST.VALIDER"
          type="button"
          title="Transformer en recrutement"
          class="btn btn-custom-primary ml-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_offre_emploi-create',
                params: { filter: 'po', id: propositionOffre.id },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_TRANSFORM" class="font-size-17"></i> Recrutement
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Poste</span>
                  </td>
                  <td>{{ propositionOffre.poste.nom }}</td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Nature du poste</span>
                  </td>
                  <td>
                    {{ propositionOffre.nature_poste.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i
                      :class="icons.ICON_CALENDAR"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold">
                      Date embauche souhaitée</span
                    >
                  </td>
                  <td>
                    {{
                      propositionOffre.date_embauche
                        ? propositionOffre.date_embauche
                        : 'Non spécifiée'
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Nombre de poste</span>
                  </td>
                  <td>{{ propositionOffre.nbre_poste }}</td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_INFO" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Type de contrat</span>
                  </td>
                  <td>
                    {{ propositionOffre.contrat_type.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i :class="icons.ICON_USER" class="text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    <span v-if="propositionOffre.created_by">
                      {{
                        propositionOffre.document.created_by.prenom
                          ? propositionOffre.document.created_by.prenom +
                            ' ' +
                            propositionOffre.document.created_by.nom
                          : propositionOffre.document.created_by.nom
                      }}
                    </span>
                    <span v-else> ### </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-4">
          <b-card class="text-black" header-class="bg-silver">
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i :class="icons.ICON_GENERIC"></i> Motif
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <p
                  class="text-dark lead"
                  style="color: black"
                  v-html="propositionOffre.motif"
                ></p>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-md-12 col-lg-4">
          <b-card class="text-black" header-class="bg-silver">
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i :class="icons.ICON_GENERIC"></i> Formations / diplômes
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <p
                  class="text-dark lead"
                  style="color: black"
                  v-html="propositionOffre.diplome_formation"
                ></p>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-md-12 col-lg-4">
          <b-card class="text-black" header-class="bg-silver">
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i :class="icons.ICON_GENERIC" class="mr-0"></i> Expériences
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <p
                  class="text-dark lead"
                  style="color: black"
                  v-html="propositionOffre.experience"
                ></p>
              </div>
            </div>
          </b-card>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card
            class="text-black"
            header-class="bg-silver border-bottom-0"
            no-body
          >
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i :class="icons.ICON_DESCRIPTION" class="mr-0"></i> Fonctions
                  / missions
                </h5>
              </div>
            </template>
            <div class="row editor">
              <div class="col-md-12">
                <vue-editor
                  id="fonction-mission"
                  v-model="propositionOffre.fonction_mission"
                  :editorToolbar="VueEditorToolbar"
                  class="fonction-mission"
                  :disabled="true"
                />
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/proposition-offre';
import CONST from '@/constants/rh/proposition-offre';
import { show as icons } from '@/icons/rh/proposition-offre';
import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';

export default {
  data() {
    return {
      propositionOffre: null,
      title: 'Gestion des demandes de recrutement - Aperçu',

      CONST,
      icons,
      VueEditorToolbar,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    VueEditor,
  },
  methods: {
    valider() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.VALIDER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    refuser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REFUSER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    reinitialiser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REINITIALISER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);

              this.init();
            })
            .catch();
        }
      });
    },
    init() {
      this.id = this.$route.params.id;

      window.axios
        .get(URL.PROPOSITION_OFFRE + '/' + this.id)
        .then((resp) => {
          this.propositionOffre = resp.data.proposition_offre;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
